import { Loading } from "app/components";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";



import Subscription from "app/views/subscription/Subscription";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { getSubscription } from "app/views/subscription/subscription.service";
import { getSessionUserInformation } from "app/utils/utility.service";

export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

const SubscriptionDialog = ({
  featureModal,
  handleSubscriptionModal,
  isDialog
}) => {


  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [featureKey, setFeatureKey] = useState("");
 
  const toast = useRef();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  const onHide = () => {

    handleSubscriptionModal(false);
   
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const navigate = useNavigate();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
 

  return (
    <Dialog
      header="My Subscription"
      visible={featureModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "90vw", maxHeight: "110vh" }}
      contentStyle={{ height: "90vh" }}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      {isLoading && <Loading />}
     <Toast ref={toast} className="ToastMessage" />
       <Elements stripe={stripePromise}>
        {!isLoading && (
      <Subscription isDialog={isDialog} onHide={onHide}></Subscription>
        )}
      </Elements>
    </Dialog>
  );
};
export default SubscriptionDialog;
